import useContentModal from "./useContentModal";

const useGuidelinesModal = () => {
  const { modalState, shouldUseModal, openContent, closeModal } =
    useContentModal("guidelines");

  // Map the generic content methods to guidelines-specific names for consistency
  const openGuideline = (guidelineId, navigate) => {
    openContent(guidelineId, navigate);
  };

  return {
    modalState: {
      isOpen: modalState.isOpen,
      guidelineId: modalState.contentId, // Map contentId to guidelineId for consistency
    },
    shouldUseModal,
    openGuideline,
    closeModal,
  };
};

export default useGuidelinesModal;